<template>
    <div class="modal-card card">
        <form @submit.prevent="onAddDocLink()">
        <div class="card-header">
            <!-- Title -->
            <h4 class="card-header-title">
                Add Documentation Link
            </h4>
            <!-- Close -->
            <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
            ></button>
        </div>
        <div class="card-body">
                <form-fields v-if="!message" :fields="fields" v-model="docLink" />
                <div v-if="error" class="text-danger">
                    {{error}}
                </div>
                <div v-if="message">
                    {{ message }}
                </div>
        </div>
        <div class="card-footer" v-if="!message">
            <div class="text-end">
                <submit-button :fields="fields" v-model="docLink" :loading="loading" />
            </div>
        </div>
        </form>
    </div>
</template>

<script>
import formFields from '../FormFields.vue';
import submitButton from '../SubmitButton.vue'
import {mapActions} from 'vuex'
import Fields, { getRouteOptions } from "../../utils/field-constants/docLinkFields.js"
import router from '../../router'

export default {
    components: { formFields, submitButton },
    data(){
        return {
            error: "",
            message: "",
            docLink: {},            
            fields: [],
            loading: false
        }
    },
    name: "AddDocLink",
    watch: {
        'docLink.route_name': {
            handler(newroute_name) {
                if (newroute_name) {
                    // Find the selected route and populate the path
                    const selectedRoute = this.routeOptions.find(option => option.value === newroute_name)
                    if (selectedRoute) {
                        this.docLink.route_path = selectedRoute.path
                    }
                }
            },
            immediate: true
        }
    },
    mounted() {
        this.initializeFields()
    },
    methods: {
        ...mapActions('admin', {
            createDocLink: 'createDocLink'
        }),
        initializeFields() {
            // Get route options
            this.routeOptions = getRouteOptions(router)
            
            // Get existing doc links for duplicate validation
            const existingDocLinks = this.$store.state.admin.docLinks || []
            
            // Update the fields with route options and validation
            this.fields = Fields.map(field => {
                if (field.name === 'route_name' && field.getOptions) {
                    return {
                        ...field,
                        options: this.routeOptions,
                        validation: [
                            ...field.validation,
                            {
                                type: 'duplicate',
                                list: existingDocLinks,
                                fieldName: 'route_name',
                                errMsg: 'A documentation link with this route name already exists'
                            }
                        ]
                    }
                } else if (field.name === 'title') {
                    return {
                        ...field,
                        validation: [
                            ...field.validation,
                            {
                                type: 'duplicate',
                                list: existingDocLinks,
                                fieldName: 'title',
                                errMsg: 'A documentation link with this title already exists'
                            }
                        ]
                    }
                } else if(field.name ==="created_by" || field.name ==="created_at" ||
                    field.name ==="updated_by" || field.name ==="updated_at"){
                    field.visible= false
                }
                return field
            })
        },
        async onAddDocLink() {
            this.loading = true;
            this.error = "";
            this.message = "";
            try {
                await this.createDocLink(this.docLink)
                this.message = "Documentation link created successfully!";
            } catch (error) {                
                if (error.response?.data?.error) 
                    this.error = error.response.data.error
                else 
                    this.error = error.message
                
                return
            }

            this.loading = false;
            this.$store.dispatch('hideModal')
            this.$store.dispatch('admin/fetchDocLinks')
        }
    }
};
</script>

<style>
</style> 